module.exports = __webpack_public_path__ + "static/img/kca-innovation.eda1a8d.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/visual-marketing-detail/kca-innovation.jpg
// module id = 8ZcD
// module chunks = 0